import React from 'react';
export function StatsStrip() {
  const stats = [{
    label: 'Startups Tracked',
    value: '250+'
  }, {
    label: 'Total Funding',
    value: '$4.2B'
  }, {
    label: 'Cities Represented',
    value: '18'
  }, {
    label: 'Active Founders',
    value: '500+'
  }];
  return <section className="border-y border-neutral-200 bg-neutral-50/50" data-id="element-149">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-150">
        <div className="grid grid-cols-2 gap-px bg-neutral-200 md:grid-cols-4" data-id="element-151">
          {stats.map((stat, i) => <div key={i} className="bg-neutral-50/50 p-8 text-center sm:p-10" data-id="element-152">
              <div className="text-3xl font-bold tracking-tight text-neutral-900 sm:text-4xl" data-id="element-153">
                {stat.value}
              </div>
              <div className="mt-2 text-sm font-medium text-neutral-500" data-id="element-154">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}